
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/15bc058aae6871dddacc3df221856caf/d4d36b6f86ae117e8d157e4db0d4a7dd.png"
              alt="Inter-American Procurement Group"
              className="h-10 w-auto mb-4"
            />
            <p className="text-sm text-gray-400 leading-relaxed">
              Simplifying Latin America Procurement for U.S. Companies
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => scrollToSection('services')} className="hover:text-orange-500 transition-colors">
                  Supplier Sourcing
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover:text-orange-500 transition-colors">
                  RFQs & Benchmarking
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover:text-orange-500 transition-colors">
                  Contract Negotiation
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover:text-orange-500 transition-colors">
                  Freight Strategy
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover:text-orange-500 transition-colors">
                  Landed Cost Analysis
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => scrollToSection('about')} className="hover:text-orange-500 transition-colors">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('industries')} className="hover:text-orange-500 transition-colors">
                  Industries
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('case-studies')} className="hover:text-orange-500 transition-colors">
                  Case Studies
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="hover:text-orange-500 transition-colors">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start">
                <i className="ri-mail-line text-orange-500 mr-2 mt-1"></i>
                <a href="mailto:info@interamericanprocurement.com" className="hover:text-orange-500 transition-colors">
                  info@interamericanprocurement.com
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-phone-line text-orange-500 mr-2 mt-1"></i>
                <a href="tel:+19543972632" className="hover:text-orange-500 transition-colors">
                  +1 (954) 397-2632
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-orange-500 mr-2 mt-1"></i>
                <span>Miami, Florida, USA</span>
              </li>
            </ul>
            <div className="flex gap-3 mt-6">
              <a href="#" className="w-9 h-9 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-orange-600 transition-colors">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-orange-600 transition-colors">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-orange-600 transition-colors">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
            <p>© 2025 Inter-American Procurement Group. All rights reserved.</p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-orange-500 transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
